import { ProductFeature, ProductFeatureStatus } from "components/product/product.types";
import { PlanProps } from "shared/components/plan/plan";
import { POWERON_PIPELINES_MARKETPLACE_URL } from "shared/constants/globals";
import { PlanOfferings } from "shared/constants/plans";
import { createItems } from "shared/constants/utilities";

export const POWERON_PIPELINES_FEATURES: ProductFeature[] = [{
  id: 'merge-validation',
  name: 'Merge Validation',
  description: 'Validate PowerOn files during pull requests and builds to prevent invalid code from merging in',
  isFeatured: true,
  isHidden: false,
  offeringType: "Subscription",
  imagePath: '/images/8b762b42-b7ad-4090-bc11-4f7484f97ef6.png',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: '',
}, {
  id: 'directory-synchronization',
  name: 'Directory Synchronization',
  description: 'Automatically sync PowerOn files from your repository to Symitar environments with SSH or HTTPS integration',
  isFeatured: true,
  isHidden: false,
  offeringType: "Subscription",
  imagePath: '/images/fc24f4e1-1202-483f-8e52-e2ac4ebd82c6.png',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: '',
}, {
  id: 'azure-devops-extension',
  name: 'Azure DevOps Extension',
  description: 'Native Azure DevOps pipeline tasks for seamless integration with your existing DevOps workflows',
  isFeatured: false,
  isHidden: false,
  offeringType: "Subscription",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: '',
}, {
  id: 'github-action',
  name: 'GitHub Action',
  description: 'Run PowerOn Pipelines workflows directly in GitHub Actions for repository-native CI/CD',
  isFeatured: false,
  isHidden: false,
  offeringType: "Subscription",
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
  docsLink: '',
}, {
  id: 'gitlab-cicd',
  name: 'GitLab CI/CD',
  description: 'Integration with GitLab CI/CD pipelines for automated PowerOn deployments',
  isFeatured: false,
  isHidden: false,
  offeringType: "Subscription",
  imagePath: '',
  status: ProductFeatureStatus.PLANNED,
  docsLink: '',
}, {
  id: 'dry-run-mode',
  name: 'Dry-Run Mode',
  description: 'Preview synchronization changes before applying them to ensure safe and predictable deployments',
  isFeatured: false,
  isHidden: true,
  offeringType: "Subscription",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: '',
}, {
  id: 'approval-gates',
  name: 'Approval Gates',
  description: 'Leverage role-based approvals for managed releases and ensure proper oversight before production deployments',
  isFeatured: false,
  isHidden: true,
  offeringType: "Subscription",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: '',
}, {
  id: 'multi-stage-deployments',
  name: 'Multi-Stage Deployments',
  description: 'Orchestrate deployments across Production, UAT, Staging, and other environments with controlled progression',
  isFeatured: false,
  isHidden: true,
  offeringType: "Subscription",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: '',
}];

export const POWERON_PIPELINES_PLAN_FEATURES = [{
  name: 'Azure DevOps & GitHub Actions support',
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
  }]
}, {
  name: 'Synchronize PowerOn files (SSH & HTTPS)',
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
  }]
}, {
  name: 'Validate PowerOn changes automatically',
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
  }]
}, {
  name: 'Multi-stage deployment orchestration',
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
  }]
}, {
  name: 'Role-based approval gates',
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
  }]
}, {
  name: 'Dry-run mode for safe deployments',
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
  }]
}, {
  name: 'Version control for Symitar environments',
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
  }]
}, {
  name: 'Pull request validation',
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
  }]
}];

export const POWERON_PIPELINES_PLAN_FEATURES_MAP = createItems(POWERON_PIPELINES_PLAN_FEATURES, 'poweron-pipelines');

export const POWERON_PIPELINES_PLAN: PlanProps = {
  header: 'Bring true CI/CD to your PowerOn development',
  features: POWERON_PIPELINES_PLAN_FEATURES_MAP,
  offerings: [{
    name: PlanOfferings.POWERON_PIPELINES,
    id: 'offering-poweron-pipelines',
    class: 'poweron-pipelines',
    link: {
      href: POWERON_PIPELINES_MARKETPLACE_URL,
      text: 'Get Started',
    }
  }]
}
